import Mutations from '../../odata/mutations';

export default { ...new Mutations('jobListingStatus'), ...new Mutations('jobListingStatuses') };
